import { getPrevPathIndex } from '@repo/shared/navigation';
import { quit } from '../pwa';

export type BackMode = boolean | 'exit';

/**
 * Performs back-navigation to the previous distinct path if available.
 * If no previous path exists and mode is 'exit', attempts to quit the webview.
 * Returns true if an action was performed (exited or navigated back), false otherwise.
 */
export function backOrExit(mode: BackMode): boolean {
	if (!mode) return false;
	const prev = getPrevPathIndex();
	const stateExit =
		(window.history.state as { onExit?: string } | null)?.onExit === 'quit';
	const shouldExit = !prev && (mode === 'exit' || stateExit) && quit();
	if (shouldExit) return true;
	if (prev) {
		window.history.go(prev[0]);
		return true;
	}
	return false;
}
